// extracted by mini-css-extract-plugin
export default {"container":"App_container__mB9ij","main":"App_main__JKHl2","paddingForMobile":"App_paddingForMobile__apYWD"};